"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var TextLabel = require('../textLabel');

var CharLimit = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CharLimit, _React$PureComponent);

  var _super = _createSuper(CharLimit);

  function CharLimit() {
    _classCallCheck(this, CharLimit);

    return _super.apply(this, arguments);
  }

  _createClass(CharLimit, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          getClassName = _this$props.getClassName,
          dataHook = _this$props.dataHook;
      return /*#__PURE__*/React.createElement("span", {
        "data-hook": dataHook,
        className: getClassName('char-limit')
      }, /*#__PURE__*/React.createElement(TextLabel, {
        dataHook: "".concat(dataHook, "-label"),
        type: "T04",
        value: this._getDisplayValue(),
        shouldTranslate: false,
        className: getClassName("char-limit-label".concat(this._validate() ? '' : '-error'))
      }));
    }
  }, {
    key: "_validate",
    value: function _validate() {
      var _this$props2 = this.props,
          maxValue = _this$props2.maxValue,
          value = _this$props2.value,
          onValidation = _this$props2.onValidation;
      var isValid = maxValue ? value <= maxValue : true;

      if (onValidation) {
        onValidation(isValid);
      }

      return isValid;
    }
  }, {
    key: "_getDisplayValue",
    value: function _getDisplayValue() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          maxValue = _this$props3.maxValue,
          minThreshold = _this$props3.minThreshold,
          maxThreshold = _this$props3.maxThreshold;

      if (maxValue && value > maxValue - maxThreshold) {
        return "".concat(value, "/").concat(maxValue);
      }

      return value >= minThreshold ? "".concat(value) : '';
    }
  }]);

  return CharLimit;
}(React.PureComponent);

CharLimit.displayName = displayNames.CHAR_LIMIT;
CharLimit.propTypes = {
  /** Hook for testing purposes  */
  dataHook: PropTypes.string,

  /** Current input length */
  value: PropTypes.number,

  /** Max characters allowed in input */
  maxValue: PropTypes.number,

  /** Minimum number of characters needed to show counter */
  minThreshold: PropTypes.number,

  /** The required distance from maxLength for displaying the value limitation */
  maxThreshold: PropTypes.number,

  /** Validation callback, expects validation boolean result */
  onValidation: PropTypes.func
};
CharLimit.defaultProps = {
  minThreshold: 1,
  maxThreshold: 10,
  onValidation: function onValidation() {}
};
module.exports = compose(CharLimit);